import { StrictFetch } from "./utils/client/base.js";
import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin(() => {
  StrictFetch.autoInit?.();
});
